<template>
    <div>
        <!-- import account -->
        <app-account></app-account>

        <!-- saved contents -->
        <div class="container spread-out">
            <template v-if="myLikes">
                <div class="row mt-3">
                    <div class="col-lg-4 col-md-6 col-12" v-for="(item, i) in myLikes" :key="i">
                        <div class="card mb-3 p-0 mx-2">
                            <div class="row">
                                <div class="col-4">
                                    <router-link :to="{ name: 'listItem', params: { id: item._id } }">
                                        <div v-if="item.itemPhoto" v-bind:style="{ backgroundImage: 'url(' + mainItemPhoto(item.itemPhoto) + ')' }" 
                                        class="liked-item-photo" :title="`${item.title} - www.anewitem.com`"></div>
                                    </router-link>
                                </div>
                                <div class="col-6 p-0">
                                    <router-link :to="{ name: 'listItem', params: { id: item._id } }">
                                        <p class="liked-item-title m-0">{{item.title}}</p>
                                        <span v-if="!item.sold" class="text-dark-green text-uppercase font-weight-bold">
                                            <!-- check if item is for donation -->
                                            <template v-if="item.donation">FREE</template>
                                            <template v-else>
                                                <!-- check if item is on sale -->
                                                <template v-if="item.onSale">
                                                    {{item.currency}} {{item.onSalePrice | money}}
                                                    <span class="strikeout">{{item.price | money}}</span>
                                                </template>
                                                <template v-else>{{item.currency}} {{item.price | money}}</template>
                                            </template>
                                        </span>
                                        <span v-else class="text-dark-green text-uppercase font-weight-bold">
                                            <span v-if="item.donation">DONATED</span>
                                            <span v-else>SOLD</span>
                                        </span>
                                        <p class="liked-item-time m-0">{{item.since | moment("MMM D 'YY hh:mm A")}}</p>
                                    </router-link>
                                </div>
                                <div class="col-2 p-0">
                                    <i @click="removeLike(item._id)" class="fas fa-heart clickable text-danger mt-2"></i> {{item.likes}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="row my-5">
                    <div class="col-12 text-muted">
                        <center>
                            <i class="far fa-frown fa-5x my-3"></i>
                            <h5>You don't seem to have liked any item yet, {{user.name | capitalize}}</h5>
                            <router-link :to="{ name: 'home' }" class="btn btn-dark-green my-5">
                                <i class="far fa-images"></i> See posted items here
                            </router-link>
                        </center>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { appendImgHostUrl } from '@/store/dry'

import Account from '../shared/Account.vue'
import UserItem from '../shared/UserItem.vue'
import LayoutUser from '@/layouts/User.vue'

export default {
    name: "Likes",
    data() {
        return {
            photoHolder: require('../../../../public/img/web/anewitem-noimage.jpg')
        }
    },
    methods: {
        ...mapActions(['displayMyLikedItems', 'footerFixed', 'dislikeItem', 'navbarCounter']),
        removeLike(itemId) {
            let dislikeObj = {
                userId: this.user._id,
                itemId: itemId
            }
            this.dislikeItem(dislikeObj)
            .then(() => {
                this.displayMyLikedItemsFxn()
                this.navbarCounter(dislikeObj).then(() => {}).catch((e) => {})
            })
            .catch((e) => {})
        },
        displayMyLikedItemsFxn() {
            let userObj = {
                userId: this.user._id
            }
            this.displayMyLikedItems(userObj).then(() => {}).catch((e) => {})
        },
        mainItemPhoto(itemPhotoPath) {
            if(itemPhotoPath){
                let src = appendImgHostUrl(itemPhotoPath)
                return src
            }
            return this.photoHolder
        },
    },
    computed: {
        ...mapGetters(['user', 'displayLikes']),
        myLikes() {
            if(this.displayLikes && this.displayLikes.length){
                if(this.displayLikes.length < 7){ this.footerFixed(true) }
                else { this.footerFixed(false) }
                return this.displayLikes
            }
            this.footerFixed(true)
            return false
        },
    },
    components: {
        appUserItem: UserItem,
        appAccount: Account
    },
    created() {
        this.displayMyLikedItemsFxn()
        this.$emit('update:layout', LayoutUser);
    }
}
</script>